module.exports = __webpack_public_path__ + "media/img/logos/horizontal/default-ad5306007fc576e00e0b7b5b6bd11909.svg";